import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ThongTinCongTy from './ThongTinCongTy';


const useStyles = makeStyles((theme) => ({
    boxTitle: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '#000',
    },
    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    // THÊM CLASS MỚI CHO HÌNH ẢNH RESPONSIVE Ở ĐÂY
    responsiveImage: {
        maxWidth: '100%', // Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử cha
        height: 'auto',   // Tự động điều chỉnh chiều cao để duy trì tỷ lệ khung hình
        display: 'block', // Đảm bảo hình ảnh là block-level để áp dụng margin tự động
        margin: theme.spacing(2, 'auto'), // Căn giữa hình ảnh và thêm khoảng cách trên/dưới
    },
}));

const BaoHanhTieuChuan = () => {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <Box className={classes.boxTitle}>
                <Typography variant="h5" className={classes.title}>
                    Chính sách bảo hành
                </Typography>
            </Box>
            <Box>
                <Typography component="span" className={classes.boldText}>BẢO HÀNH TIÊU CHUẨN</Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Công ty cổ phần ô tô TNF có trách nhiệm về mặt pháp lý cung cấp bảo hành cho tất cả các sản phẩm của  hãng xe Ford được bán ra tại Thái Nguyên Ford.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/1.jpg' className={classes.responsiveImage} alt="Thái Nguyên Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    TỔNG QUAN
                </Typography>
                <Typography variant="body1" >
                    Được công bố thành văn bản về trách nhiệm của công ty đối với việc sửa chữa và thay thế những phụ tùng có khuyết tật. Đó cũng là trách nhiệm của Công ty cổ phần ô tô TNF trong việc bảo đảm rằng những mối quan tâm về bảo hành của khách hàng được quản lý một cách đúng đắn và được công nhận một cách thích hợp đáp ứng sự mong đợi của khách hàng về độ tin cậy của sản phẩm. Thái Nguyên Ford sẽ bảo hành cho các chủ sở hữu xe Ford mua tại Thái Nguyên Ford,đối với bất kỳ khuyết tật nào về vật liệu chế tạo trong thời gian 3 năm hoặc 100.000 km tuỳ theo điều kiện nào tới trước tính từ ngày giao xe hay bắt đầu sử dụng. Dưới chế độ bảo hành này, mọi công việc sửa chữa hay thay thế đều được miễn phí về phụ tùng chính hiệu và công lao động.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/2.jpg' className={classes.responsiveImage} alt="Khai trương đại lý" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    TRÁCH NHIỆM CỦA KHÁCH HÀNG
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Có một số lưu ý khách hàng cần phải thực hiện để đảm bảo mình có được lợi ích lớn nhất từ các điều khoản bảo hành của Ford:
                </Typography>
                <Box>
                    <ul>
                        <li>Khách hàng có trách nhiệm sử dụng, bảo quản và chăm sóc xe theo như sổ tay hướng dẫn sử dụng xe.</li>
                        <li>Đảm bảo rằng chỉ sử dụng loại nhiên liệu đã được quy định.</li>
                        <li>Lưu giữ các bản ghi kiểm tra và dịch vụ bảo dưỡng định kỳ để làm rõ lai lịch bảo dưỡng xe, nếu được yêu cầu.</li>
                        <li>Đảm bảo rằng bất kỳ khuyết tật hay lỗi hư hỏng nào phát sinh trong bất kỳ cụm chi tiết nào được bao gồm trong bảo hành phải được sửa chữa ngay lập tức.</li>
                        <li>Hãy đem xe của bạn tới các đại lý hoặc trung tâm uỷ quyền của Ford trong giờ hành chính để làm bảo hành.</li>
                    </ul>
                </Box>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/3.jpg' className={classes.responsiveImage} alt="Sửa chữa Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    CÁC MỤC KHÔNG CÓ TRONG BẢO HÀNH
                </Typography>
                <br />
                <Box>
                    <ul>
                        <li>Hỏng hóc do nguyên nhân tai nạn, cháy hoặc các tai nạn khác, hư hỏng do nguyên nhân thiếu bảo dưỡng định kỳ theo quy định của Thái Nguyên Ford.</li>
                        <li>Hư hỏng do sử dụng sai mục đích, cẩu thả thiếu sự chăm sóc bảo dưỡng và cất giữ xe không đúng như mô tả trong tài liệu hưỡng dẫn sử dụng xe</li>
                        <li>Những hư hỏng do sử dụng phụ tùng không chính hãng hoặc sử dụng trong tình trạng quá tải theo quy định của nhà sản xuất.</li>
                        <li>Những hao mòn theo thời gian như phai màu tự nhiên của các bề mặt sơn, các bề mặt mạ, bọc đệm hoặc các phụ tùng hao mòn theo thời gian sử dụng như các loại lõi lọc, má phanh hay bugi</li>
                        <li>Những xe mà đồng hồ chỉ thị số Km bị thay đổi nên việc nhận biết số Km thực tế không còn đúng.</li>
                        <li>Công ty cổ phần ô tô TNF không chịu các chi phí ngẫu nhiên như bồi hoàn mất mát về sử dụng xe, thời gian, cơ hội, mất mát kinh tế trong thời gian không sử dụng xe.</li>
                    </ul>
                </Box>
                <br />
                <br />
                <ThongTinCongTy />
            </Box>
        </Box>
    );
};

export default BaoHanhTieuChuan;